module.exports = __webpack_public_path__ + "static/media/bg-img.00eb2683.jpg";